import AuthLayout from '@/components/common/AuthLayout';
import NewUserInformationForm from '@/components/new-user/NewUserInformationForm';
import { useTranslation } from 'react-i18next';

export default function NewUserInformationPage() {
  const { t } = useTranslation(['new-user']);
  return (
    <AuthLayout title={t('title')} background="gradient" returnIcon={true} isNew={true}>
      <NewUserInformationForm />
    </AuthLayout>
  );
}
